<template>
    <div class="action-table">
        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square
                slot="cls_column"
                slot-scope="props"
                :name="props.row.type"
                :length="1"
                :color="setColorOfColoredLetterSquare(props.row.type)"
            >
            </colored-letter-square>

            <div
                slot="resubmit_at"
                slot-scope="props"
                v-text="formatDate(props.row.resubmit_at)"
            ></div>

            <div slot="actions" slot-scope="props">
                <main-learning-content-table-actions
                    :data="props.row"
                    :index="props.index"
                ></main-learning-content-table-actions>
            </div>
        </v-client-table>
    </div>
</template>

<script>
import moment from 'moment';
import { Event } from 'vue-tables-2';
import { EventBus } from '../eventbus';

export default {
    data() {
        return {
            tableData: [],
            columns: [
                'cls_column',
                'name',
                'comment',
                'type',
                'resubmit_at',
                'actions',
            ],
            options: {
                headings: {
                    cls_column: '',
                    name: this.trans('learning_contents.label.name'),
                    comment: this.trans('learning_contents.label.comment'),
                    type: this.trans('learning_contents.label.type'),
                    resubmit_at: this.trans(
                        'learning_contents.label.resubmit_at'
                    ),
                    actions: this.trans('vuetables.label.actions'),
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search'),
                },

                sortable: ['name', 'type', 'resubmit_at'],
            },
        };
    },

    created() {
        this.fetch();
    },

    mounted() {
        EventBus.$on('onDelete', deleteId => {
            var index = this.tableData.findIndex(data => data.id == deleteId);
            this.tableData.splice(index, 1);
        });

        var filter = this.debounce(query => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });
    },

    methods: {
        fetch() {
            axios
                .get(this.route('mainapi.learning-contents.index'))
                .then(this.refresh);
        },

        refresh({ data }) {
            this.tableData = data.data;
            window.scrollTo(0, 0);

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        },

        formatDate(date) {
            return date
                ? moment(date)
                      .locale('de')
                      .format('DD.MM.YYYY')
                : null;
        },

        setColorOfColoredLetterSquare(type) {
            switch (type) {
                case this.trans('learning_contents.type.image'):
                    return '#79bc52';
                case this.trans('learning_contents.type.video'):
                    return '#f8cc99';
                case this.trans('learning_contents.type.pdf'):
                    return '#d65c5c';
                case this.trans('learning_contents.type.dlc'):
                    return '#e899ca';
                case this.trans('learning_contents.type.wbt'):
                    return '#f48fb1';
            }
        },
    },
};
</script>
